import { OrganizationContact } from '@/features/organization/api/OrganizationModel'
import { useTranslation } from 'react-i18next'
import { CardBody, InputGroup } from '@/common'
import { useCallback, useState } from 'react'
import EmailInputGroup from '@/shared/components/forms/EmailInputGroup'

export default function OrganizationContactForm({
  initialState,
  onChange
}: {
  initialState: OrganizationContact
  onChange: (contact: OrganizationContact) => void
}) {
  const { t } = useTranslation()
  const [state, setState] = useState(initialState)
  const { contactPhoneNumber, contactEmail, contactName } = state

  const onInputChange = useCallback(
    (evt: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
      setState({ ...state, [evt.target.id]: evt.target.value })
      onChange({ ...state, [evt.target.id]: evt.target.value })
    },
    [state, onChange]
  )

  return (
    <div className="sm:flex sm:gap-2 sm:items-end">
      <div className="sm:w-3/5 mb-2 sm:mb-0">
        <CardBody className="space-y-2">
          <InputGroup
            id="contactName"
            label={t('settings:organizationDetails.contact.fields.contactName')}
            value={contactName}
            onChange={onInputChange}
            required
          />
          <EmailInputGroup
            id="contactEmail"
            label={t('common:inputFields.email.label')}
            value={contactEmail}
            onChange={onInputChange}
            required
          />
          <InputGroup
            id="contactPhoneNumber"
            label={t('common:inputFields.phoneNumber.label')}
            value={contactPhoneNumber}
            onChange={onInputChange}
            required
          />
        </CardBody>
      </div>
    </div>
  )
}
